export default {"src":"/_next/static/media/Handy-Burger.b5f14cb8.svg","height":737,"width":709,"blurWidth":0,"blurHeight":0};